import { AppMessageBox } from "components/AppMessageBox";
import * as React from "react";

export const PublicationNoDataInfo: React.FC<{}> = (props) => {
    return <AppMessageBox resource="PublicationNotFound" variant="error" />;
};
